import { render, staticRenderFns } from "./PowerPage.vue?vue&type=template&id=2ee33c51&scoped=true"
import script from "./PowerPage.vue?vue&type=script&lang=js"
export * from "./PowerPage.vue?vue&type=script&lang=js"
import style0 from "./PowerPage.vue?vue&type=style&index=0&id=2ee33c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee33c51",
  null
  
)

export default component.exports